import { Trans, useTranslation } from "react-i18next";
import CustomModal from "components/lib/customModal";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const DescriptionInfoModal = ({ open, onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <CustomModal.Wrapper
      size="medium"
      onClose={() => onClose()}
      open={open}
      titleText={t("PRESENTATION")}
      isScrollable
    >
      <p>
        <Trans
          i18nKey="DESCRIPTION_INFO_TEXT"
          components={{
            strong: <strong />,
            em: <em />,
            li: <li />,
            ul: <ul />,
            h4: <h4 />,
          }}
        />
      </p>
    </CustomModal.Wrapper>
  );
};
